"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _ThemeProvider = _interopRequireDefault(require("../ThemeProvider"));

var _mediaQueries = require("../../utils/media-queries");

var _Scrollfix = _interopRequireDefault(require("../Scrollfix"));

var _styled = require("./styled");

var _propTypes = _interopRequireDefault(require("prop-types"));

var Overlay =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(Overlay, _Component);

  function Overlay() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2["default"])(this, Overlay);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2["default"])(this, (_getPrototypeOf2 = (0, _getPrototypeOf3["default"])(Overlay)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "stopPropagation", function (e) {
      e.stopPropagation();
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "renderOverlay", function () {
      var _this$props = _this.props,
          closePortal = _this$props.closePortal,
          isOnBottom = _this$props.isOnBottom,
          children = _this$props.children;
      return _react["default"].createElement(_styled.Wrapper, {
        onMouseDown: closePortal,
        isOnBottom: isOnBottom
      }, _react["default"].createElement(_styled.OverlayContentWrap, {
        isOnBottom: isOnBottom
      }, _react["default"].createElement(_styled.OverlayContent, {
        onMouseDown: _this.stopPropagation,
        isOnBottom: isOnBottom
      }, _react["default"].cloneElement(children, {
        closePortal: closePortal
      }))));
    });
    return _this;
  }

  (0, _createClass2["default"])(Overlay, [{
    key: "render",
    value: function render() {
      var scrollFix = this.props.scrollFix;

      if (!scrollFix) {
        return _react["default"].createElement(_ThemeProvider["default"], null, this.renderOverlay());
      }

      return _react["default"].createElement(_ThemeProvider["default"], null, _react["default"].createElement(_Scrollfix["default"], null, this.renderOverlay()));
    }
  }]);
  return Overlay;
}(_react.Component);

(0, _defineProperty2["default"])(Overlay, "defaultProps", {
  scrollFix: true
});
(0, _defineProperty2["default"])(Overlay, "propTypes", {
  closePortal: _propTypes["default"].func.isRequired,
  isOnBottom: _propTypes["default"].bool.isRequired,
  children: function children() {
    return (typeof _react.bpfrpt_proptype_Element === "function" ? _react.bpfrpt_proptype_Element.isRequired ? _react.bpfrpt_proptype_Element.isRequired : _react.bpfrpt_proptype_Element : _propTypes["default"].shape(_react.bpfrpt_proptype_Element).isRequired).apply(this, arguments);
  },
  scrollFix: _propTypes["default"].bool
});

var _default = (0, _mediaQueries.withMedia)(Overlay);

exports["default"] = _default;